import {
  MessageResponseDto,
  GetEmployeeBucketDto,
  CreateEmployeeBucketDto,
  EditEmployeeBucketDto,
  EmployeeBucketControllerGet200Response,
  EmployeeBucketApiFp,
  DeleteEmployeeBucketDto,
  EmployeeBucketControllerBucketWithTemporaryBranch200Response,
  OffboardEmployeeBucketDto,
  SuspendEmployeeBucketDto,
} from "@api/api";
import { apiConfig } from "@core/query/config.query";
import { QueryKey } from "@core/query/query-key.enum";

export type GetResponseEmployeeBucketModel =
  | EmployeeBucketControllerGet200Response & Partial<{ score: number }>;
export type GetEmployeeBucketTempResponse =
  EmployeeBucketControllerBucketWithTemporaryBranch200Response;
export type GetEmployeeBucketModel = GetEmployeeBucketDto;
export type MutateResponseEmployeeBucketModel = MessageResponseDto;
export type CreateEmployeeBucketModel = CreateEmployeeBucketDto;
export type UpdateEmployeeBucketModel = EditEmployeeBucketDto;
export type DeleteEmployeeBucketModel = DeleteEmployeeBucketDto;
export type OffboardEmployeeBucketModel = OffboardEmployeeBucketDto;
export type SuspendEmployeeBucketModel = SuspendEmployeeBucketDto;


export const apiEmployeeBucketFp = EmployeeBucketApiFp(apiConfig);
export const getEmployeeBucketController =
  apiEmployeeBucketFp.employeeBucketControllerGet;
export const getEmployeeBucketWithTempController =
  apiEmployeeBucketFp.employeeBucketControllerBucketWithTemporaryBranch;
export const createEmployeeBucketController =
  apiEmployeeBucketFp.employeeBucketControllerCreate;
export const updateEmployeeBucketController =
  apiEmployeeBucketFp.employeeBucketControllerEdit;
export const deleteEmployeeBucketController =
  apiEmployeeBucketFp.employeeBucketControllerDelete;
export const offboardEmployeeBucketController =
  apiEmployeeBucketFp.employeeBucketControllerOffboard;
export const suspendEmployeeBucketController =
  apiEmployeeBucketFp.employeeBucketControllerSuspend;

export const QueryKeyEmployeeBucket = QueryKey.EmployeeBucket;
